var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMnu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "px",
    height: "px",
    viewBox: "0 0 532 532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    style: {
      fill: "#000042",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000042",
      fillOpacity: 1
    },
    d: "M 132.457031 337 L 399.699219 337 C 416.078125 337 429.355469 350.277344 429.355469 366.65625 C 429.355469 383.039062 416.078125 396.316406 399.699219 396.316406 L 132.457031 396.316406 C 116.078125 396.316406 102.796875 383.039062 102.796875 366.65625 C 102.796875 350.277344 116.078125 337 132.457031 337 Z M 132.457031 337 ",
    id: "path30097"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000042",
      fillOpacity: 1
    },
    d: "M 132.457031 236.417969 L 399.699219 236.417969 C 416.078125 236.417969 429.355469 249.699219 429.355469 266.078125 C 429.355469 282.457031 416.078125 295.734375 399.699219 295.734375 L 132.457031 295.734375 C 116.078125 295.734375 102.796875 282.457031 102.796875 266.078125 C 102.796875 249.699219 116.078125 236.417969 132.457031 236.417969 Z M 132.457031 236.417969 ",
    id: "path30099"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000042",
      fillOpacity: 1
    },
    d: "M 132.457031 135.839844 L 399.699219 135.839844 C 416.078125 135.839844 429.355469 149.117188 429.355469 165.496094 C 429.355469 181.878906 416.078125 195.15625 399.699219 195.15625 L 132.457031 195.15625 C 116.078125 195.15625 102.796875 181.878906 102.796875 165.496094 C 102.796875 149.117188 116.078125 135.839844 132.457031 135.839844 Z M 132.457031 135.839844 ",
    id: "path30101"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnu);
export default __webpack_public_path__ + "static/media/mnu.04c9e0c8a7056a9ab49c3b748bf63085.svg";
export { ForwardRef as ReactComponent };